'use client';

import { AnchorNavigation } from '../ui/navigation/anchor-navigation/AnchorNavigation';

import { anchorNavigationSettings } from '@mage-ui/styled-system/recipes';

export const Navigation = ({ instances, isRelation, variant = 'primary' }) => {
  if (!instances || instances.length === 0) {
    return null;
  }
  return (
    <AnchorNavigation
      isRelation={isRelation}
      data={{
        label: 'Selecciona una opció',
        items: instances,
      }}
      classNames={anchorNavigationSettings({ variant })}
      withArrow={variant !== 'tertiary' ?? true}
    />
  );
};
